import ReactDOM from 'react-dom/client';
import App from '@/App';

import '@style/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
<App/>
)